import React, { FC, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
  FormControlLabel,
  Box,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

export interface UserInformationProps {
  isOpen: boolean;
  onClose: () => void;
  onConsent: () => void;
}

const REQUIREMENTS: readonly string[] = [
  'I hold a valid home country driving license accepted in the UAE or an International Driving Permit (UAE driving license is mandatory for residents).',
  'I have a physical credit or debit card available with me.',
  'I agree to a pre-authorisation hold on my credit card or to pay a deposit via debit card.',
];

export const UserInformation: FC<UserInformationProps> = ({
  isOpen,
  onClose,
  onConsent,
}) => {
  const [isChecked, setIsChecked] = useState<boolean>(false);

  const handleProceed = (): void => {
    if (!isChecked) return;
    onConsent();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      aria-labelledby="terms-and-conditions-title"
    >
      <DialogTitle id="terms-and-conditions-title">
        Required Documents
      </DialogTitle>

      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" mb={2}>
          Please review and confirm the following requirements before proceeding
          with your booking.
        </Typography>

        <Box
          component="ul"
          sx={{
            m: 0,
            pl: 3,
            listStyleType: 'disc',
            '& li': {
              mb: 1,
            },
          }}
        >
          {REQUIREMENTS.map((item, index) => (
            <Box component="li" key={index}>
              <Typography variant="body1" color="text.primary">
                {item}
              </Typography>
            </Box>
          ))}
        </Box>

        {/* <List disablePadding>
          {REQUIREMENTS.map((item, index) => (
            <ListItem key={index} alignItems="flex-start" sx={{ py: 1 }}>
              <ListItemIcon sx={{ mt: 0.5 }}>
                <CheckCircleOutlineIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body1">{item}</Typography>}
              />
            </ListItem>
          ))}
        </List> */}

        <Box mt={3}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
                color="primary"
              />
            }
            label={
              <Typography variant="body2">
                I accept the terms & conditions.
              </Typography>
            }
          />
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          py: 2,
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 1,
        }}
      >
        <Button variant="outlined" color="inherit" fullWidth onClick={onClose}>
          Cancel
        </Button>

        <Button
          // variant="contained"
          onClick={handleProceed}
          className={isChecked && 'btn'}
          disabled={!isChecked}
          fullWidth
          color="primary"
        >
          Yes, I Agree & Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};
